import { gql, useMutation } from "@apollo/client";
import useSnackbar from "src/utils/hook/base/useSnackbar";
import useErrorHandling from "src/utils/hook/base/useErrorHandling";
import useRequestBeforeLogin from "src/utils/hook/base/useRequestBeforeLogin";

//Schema definition
const M_CreateContactUs = gql`
  mutation createContactUs($data: ContactUsCreateInput!) {
    createContactUs(data: $data) {
      message
      statusCode
    }
  }
`;

const useCreateContactUs = () => {
  const { errorHandling } = useErrorHandling();
  const { requestConfig } = useRequestBeforeLogin();
  const [mutate, { loading }] = useMutation(M_CreateContactUs, requestConfig({ module: "AVC_TICKET" }));

  const { snack } = useSnackbar();

  const createContactUs = (values) => {
    mutate({
      variables: {
        data: {
          firstName: values?.firstName,
          lastName: values?.lastName,
          title: values?.title,
          phoneNumber: values?.phoneNumber,
          email: values?.email,
          text: values?.text,
          subject: values?.subject,
          subcategory: values?.subcategory,
          businessTitle: values?.businessTitle,
        },
      },

      onCompleted: (data) => {
        if (data.createContactUs.statusCode === 1201) {
          snack.success({
            title: data.createContactUs.message,
          });
        } else {
          snack.error({
            title: data.createContactUs.message,
          });
        }
      },
      onError: (error) => {
        errorHandling(error);
      },
    });
  };
  return { createContactUs, loading };
};

export default useCreateContactUs;
